import React from "react";
import "./CertifiedSection.css"; // Add your custom styles here

const certifications = [
  {
    id: 1,
    icon: "fas fa-award", // FontAwesome icon class for CPC
    title: "CPC",
  },
  {
    id: 2,
    icon: "fas fa-file-alt", // FontAwesome icon class for BCHH-C
    title: "BCHH-C",
  },
  {
    id: 3,
    icon: "fas fa-medal", // FontAwesome icon class for HCS-D / HCS-O
    title: "HCS-D / HCS-O",
  },
];

const Certificate = () => {
  return (
    <section id="certified-section">
      <h2>OUR TEAM IS CERTIFIED</h2>
      <div className="certifications-container">
        {certifications.map((cert) => (
          <div key={cert.id} className="certification-item">
            <div className="icon-container">
              <i className={cert.icon}></i>
            </div>
            <p className="certification-title">{cert.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Certificate;
